/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';
import { sizeChoices } from '../helpers';

const isNotText = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TEXT',
]);

const isNotTextTypeTitle = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'text_type',
  '!==',
  'TITLE',
]);

const isNotTextSizeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'text_size',
  '!==',
  'CUSTOM',
]);

const isTextViewingEffects = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '===',
  'effects',
]);

const isTextNotViewingEffects = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '!==',
  'effects',
]);

const isTextViewingEffectsHover = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '===',
  'effectsHover',
]);

const isTextNotViewingEffectsHover = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '!==',
  'effectsHover',
]);

export default [
  ...[
    ['FieldHidden', {
      name: '_viewing',
      label: null,
    }],
    getFilterWithCol(['FieldRichTextInline', {
      name: 'text_value',
      label: null,
      placeholder: 'Text',
      i18nTranslatable: true,
    }], 24),
    getFilterWithCol(['FieldRadio', {
      label: null,
      name: 'text_type',
      initialValue: 'TITLE',
      choices: ['Title', 'Label'].map(label => ({
        label,
        value: label.toUpperCase(),
      })),
      block: true,
    }]),
    getFilterWithCol(['FieldRadio', {
      name: 'text_align',
      label: null,
      initialValue: 'LEFT',
      choices: ['Left', 'Center', 'Right'].map(label => ({
        value: label.toUpperCase(),
        label,
      })),
      block: true,
    }], 24),
    getFilterWithCol(['FieldRadio', {
      name: 'text_size',
      label: null,
      initialValue: 'MEDIUM',
      choices: [
        ...sizeChoices,
        {
          label: 'Custom',
          value: 'CUSTOM',
        },
      ],
      block: true,
      skip: [isNotTextTypeTitle],
    }], 24),
    getFilterWithCol(['FieldText', {
      name: 'text_sizeCustom',
      label: null,
      prefix: 'Size:',
      skip: [isNotTextTypeTitle, isNotTextSizeCustom],
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      hidden: [isTextViewingEffects, isTextViewingEffectsHover],
      preSkip: [isNotText, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderEffectsText', {
    name: 'text_effects',
    hidden: [isTextNotViewingEffects],
    preSkip: [isNotText],
  }],
  ['FieldContentBuilderEffectsText', {
    name: 'text_effectsHover',
    hidden: [isTextNotViewingEffectsHover],
    preSkip: [isNotText],
    addButtonLabel: 'Add Hover Effect',
    pasteButtonLabel: 'Paste Hover Effect',
  }],
];
